import type { SalesAction } from '@shared/types/sales-action';

/// 一覧タブ判定に必要な最小フィールドだけを受ける (テスト容易性のため)。
type LifecycleView = Pick<SalesAction, 'action_status' | 'sales_status'>;

/**
 * 現在の次アクション: 実行中 (`action_status === 'open'`) かつ
 * 顧客ステータスが受注/失注以外。 営業担当が今まさに進める対象。
 */
export function isCurrentAction(action: LifecycleView): boolean {
  return (
    action.action_status === 'open' &&
    action.sales_status !== 'won' &&
    action.sales_status !== 'lost'
  );
}

/**
 * 結果: 完了 (`action_status === 'completed'`) かつ顧客ステータスが受注/失注。
 * 受注・失注だけがここに移る (中間ステータスでの完了は履歴であり、 どちらの
 * タブにも出さない)。
 */
export function isResultAction(action: LifecycleView): boolean {
  return (
    action.action_status === 'completed' &&
    (action.sales_status === 'won' || action.sales_status === 'lost')
  );
}
